<template>
<div id="form-container" ref="formContainer">
  <b-button style="float:right;" type="button" variant="primary" @click="goBack">Back</b-button>
    <h1>Submit New HRM Request</h1>

    <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

    <b-form v-if="!isSubmitted" @submit.stop.prevent="onSubmit">
        <div class="card">
            <div class="card-header">Type of Request</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12">
                        <BasePositionStatus v-model="request.requestTypeValue"
                            :v="$v.request.requestTypeValue"
                            label="Type of Request"
                            slug="requestType"
                            :key="keys.requestType"
                            :required="false"
                            tip="What type of request is being submitted. Based on type selected different form options are displayed."
                        />
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white"
            v-if="_.includes(['01', '02', '03','04', '05', '06', '07', '08','12'], request.requestTypeValue.code)">
            <div class="card-header">Position Information</div>
            <div class="card-body">

                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseTextInput v-model="request.positionNumber" 
                            :v="$v.request.positionNumber"
                            label="Position Control Number"
                            tip="Should be 8 digits. Use leading zeroes as needed. If new/unknown enter 00000000."
                            v-on:change.native="padPositionNumber"
                            slug="pcn"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="12" v-show="!_.includes(['10'], request.requestTypeValue.code)">
                        <hr>
                        <b-button size="sm" v-on:click="getSema4AttributesOfCurrentPcn(request.positionNumber)"
                                  aria-label="pcn search button"
                                  v-b-toggle.collapse-3
                                  class="mb-4">Click Here to Display Position Related Attributes from SEMA4/HR/Payroll System
                        </b-button>
                        <BaseSema4Attributes :pcn-sema4-attributes="pcnSema4Attributes[0]"
                                             :funding-data="fundingData"
                        />
                        <hr>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseTextInput v-model="request.previousIncumbent"
                                       :v="$v.request.previousIncumbent"
                                       label="Previous Incumbent"
                                       slug="previousEmployee"
                                       tip="If any."/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseClassificationSelector v-model="request.proposedClassification"
                            :v="$v.request.proposedClassification"
                            slug="classification"
                            label="Proposed Classification"
                            sr="Search for Proposed Classification"
                            :required="$v.request.proposedClassification.$params.required ? true : false"/>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <BaseTextInput v-model="request.classOption" 
                            :v="$v.request.classOption"
                            slug="classOption"
                            label="Class Option"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.appointmentValue.code" 
                            :v="$v.request.appointmentValue.code"
                            label="Appointment Type"
                            slug="appointmentType"
                            :required="$v.request.appointmentValue.code.$params.required ? true : false"
                            :options = appointmentTypeOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                         <BaseSelector v-model="request.superPosition" 
                            :v="$v.request.superPosition"
                            label="New Supervisory Position?"
                            slug="superPosition"
                            :options = yesNoOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="request.workingTitle" 
                            :v="$v.request.workingTitle"
                            slug="workingTitle"
                            :required="$v.$params.required ? true : false"
                            label="Working Title"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.positionScheduleValue.code" 
                            :v="$v.request.positionScheduleValue.code"
                            label="Employment Condition"
                            slug="fte"
                            :required="$v.request.positionScheduleValue.code.$params.required ? true : false"
                            :options = positionScheduleOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseLocationSelector v-model="request.positionLocation"
                            :v="$v.request.positionLocation"
                            :required="$v.request.positionLocation.$params.required ? true : false"
                            slug="location"
                            label="Position Location"/>

                    </b-col>
                    <b-col cols="12" lg="4">
                <BaseSelector v-model="request.workTravelValue.code" 
                    :v="$v.request.workTravelValue.code"
                    label="Travel Requirement"
                    slug="travel"
                    :required="$v.request.workTravelValue.code.$params.required ? true : false"
                    :options = workTravelOptions />
            </b-col>
                </b-row>

        <b-row>
            
            <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.hoursPerWeek" 
                    :v="$v.request.hoursPerWeek"
                    label="Hours Per Week"
                    slug="stdHours"
                    :required="$v.request.hoursPerWeek.$params.required ? true : false"
                    tip="Hours per week cannot be more than 40"/>

            </b-col>
                        <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.workingHours" 
                    :v="$v.request.workingHours"
                    label="Work Hours"
                    slug="workingHours"
                    :required="$v.request.workingHours.$params.required ? true : false"
                    tip="Example: 8:00 am - 4:30 pm"/>
            </b-col>
            <b-col cols="12" lg="4">
                <BaseSelector v-model="request.workScheduleValue.code" 
                    :v="$v.request.workScheduleValue.code"
                    label="Work Schedule"
                    slug="schedule"
                    tip=""
                    :required="$v.request.workScheduleValue.code.$params.required ? true : false"
                    :options = workScheduleOptions />
            </b-col>

        </b-row>

        <b-row>
            <b-col cols="12" lg="4">                
                <BaseDateInput v-model="request.anticipatedStartDate" 
                    :v="$v.request.anticipatedStartDate"
                    label="Anticipated Start Date"
                    slug="start-date"
                    :required="true"/>
            </b-col>
            <b-col cols="12" lg="4">
                <BaseDateInput v-model="request.endDate" 
                    :v="$v.request.endDate"
                    label="End Date"
                    slug="end-date"
                    :required="false"/>
            </b-col>
        </b-row>

        <b-row v-if="request.appointmentValue && request.appointmentValue.code === 'N'">
             <b-col cols="12">
                    <BaseParagraphInput v-model="request.timeLimitedReason"
                        :v="$v.request.timeLimitedReason"
                        label="Explain why the position is time-limited (cannot be based on funding alone)"
                        slug="timeLimitedReason"
                        tip=""/>
            </b-col>

            <b-col cols="12">
                    <BaseSelector v-model="request.endWhenWorkComplete" 
                    :v="$v.request.endWhenWorkComplete"
                    label="If work completed earlier than expected, is the intent to end incumbent''s position immediately?"
                    slug="endWhenWorkComplete"
                    :options = yesNoOptions />
            </b-col>

            <b-col cols="12">
                    <BaseParagraphInput v-model="request.purposeOfPosition"
                        :v="$v.request.purposeOfPosition"
                        label="Summary of purpose/primary role of the position and primary clientele, if any"
                        slug="purposeOfPosition"
                        tip=""/>
            </b-col>
 
        </b-row>
            </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white"
            v-if="_.includes(['09'], request.requestTypeValue.code)">
            <div class="card-header">Redeployment/Re-assignment Information</div>
            <div class="card-body">

                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseSelector v-model="request.coopLevel" 
                            :v="$v.request.coopLevel"
                            label="COOP Level of Position"
                            slug="coop"
                            :options = coopOptions />
                    </b-col>

                    <b-col cols="12" lg="6">
                        <BaseSelector v-model="request.positionScheduleValue.code" 
                            :v="$v.request.positionScheduleValue.code"
                            label="Employment Condition"
                            slug="fte"
                            :options = positionScheduleOptions />
                    </b-col>                
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="request.hoursPerWeek" 
                            :v="$v.request.hoursPerWeek"
                            label="Hours Per Week"
                            slug="stdHours"
                            tip="Hours per week cannot be more than 40"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.workScheduleValue.code" 
                            :v="$v.request.workScheduleValue.code"
                            label="Work Schedule"
                            slug="schedule"
                            tip=""
                            :options = workScheduleOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseLocationSelector v-model="request.positionLocation"
                            :v="$v.request.positionLocation"
                            :required="$v.request.positionLocation.$params.required ? true : false"
                            slug="location"
                            label="Position Location"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.workTravelValue.code" 
                        :v="$v.request.workTravelValue.code"
                        label="Travel Requirement"
                        slug="travel"
                        :options = workTravelOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.dlRequired" 
                        :v="$v.request.dlRequired"
                        label="Driver's License Required"
                        slug="dlrequired"
                        :options = yesNoOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.teleworkAvailable" 
                        :v="$v.request.teleworkAvailable"
                        label="Employee is Available to Telework"
                        slug="telework"
                        :options = yesNoUnknownOptions />
                    </b-col>
                </b-row>
                
                <b-row>
                    <b-col cols="12" lg="4">                
                        <BaseDateInput v-model="request.anticipatedStartDate" 
                            :v="$v.request.anticipatedStartDate"
                            label="Anticipated Start Date"
                            slug="start-date"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseDateInput v-model="request.endDate" 
                            :v="$v.request.endDate"
                            label="End Date"
                            slug="end-date"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Required Skill Set">
                            <b-form-checkbox-group
                            stacked
                            v-model="selectedSkills"
                            :options="skillSetOptions"
                            name="skillSet"
                            value-field="value"
                            text-field="text">
                            </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <BaseTextInput v-model="request.otherSkillSet" v-if="hasOtherRequiredSkill"
                            :v="$v.request.otherSkillSet"
                            label="Other Skill Set"
                            slug="otherSkillSet"/>
                        
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white"
            v-if="_.includes(['10'], request.requestTypeValue.code)">
            <div class="card-header">Leave Request Information</div>
            <div class="card-body">

                <b-row>
                    <b-col cols="12">
                        <BaseEmployeeSelector v-model="request.employee"
                            label="Employee"
                            :v="$v.request.employee"
                            slug="employee"
                            tip="Enter employee’s last or first name or PCN to narrow list"
                            :showPcn="true"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.leaveType" 
                            :v="$v.request.leaveType"
                            label="Leave Type"
                            slug="leaveType"
                            :options = leaveTypeOptions />
                    </b-col>
                    <b-col cols="12" lg="4" v-show="false">
                        <BaseSelector v-model="request.teleworkAvailable" 
                        :v="$v.request.teleworkAvailable"
                        label="Employee is Available to Telework"
                        slug="telework"
                        :options = yesNoUnknownOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.positionScheduleValue.code" 
                            :v="$v.request.positionScheduleValue.code"
                            label="Employment Condition"
                            slug="fte"
                            :options = positionScheduleOptions />
                    </b-col>                      
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">                
                        <BaseDateInput v-model="request.anticipatedStartDate" 
                            :v="$v.request.anticipatedStartDate"
                            label="Anticipated Start Date"
                            slug="start-date"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseDateInput v-model="request.endDate" 
                            :v="$v.request.endDate"
                            label="Anticipated End Date"
                            slug="end-date"/>
                    </b-col>
                </b-row>
            </div>
        </div>

    <div class="card" v-if="_.includes(['01', '02', '03','04', '05', '06', '07', '08', '09', '10','12'], request.requestTypeValue.code)">
        <div class="card-header">Organizational Information</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseDivisionSelector v-model="request.division"
                        :v="$v.request.division"
                        :required="$v.request.division.$params.required ? true : false"
                        slug="division"
                        label="Division"
                        @input="updateDivision"
                    />
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseDepartmentSelector v-model="request.departmentId"
                        :v="$v.request.departmentId"
                        :required="$v.request.departmentId.$params.required ? true : false"
                        slug="department"
                        label="Department ID"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.unitName" 
                        :v="$v.request.unitName"
                        :required="$v.request.unitName.$params.required ? true : false"
                        slug="unit"
                        label="Unit Name"/>
                </b-col>
            </b-row>
            <b-row v-if="!_.includes(['10', '13'], this.request.requestTypeValue.code)">
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="First Approver (Division Director)"
                                    :value="request.divisionDirector"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Second Approver (Assistant Commissioner)"
                                    :value="request.assistantCommissioner"
                    />
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Staffing Specialist"
                                    :value="request.staffingSpecialist"/>
                </b-col>
            </b-row>
        </div>
    </div>
       
       
    <div class="card" v-if="_.includes(['01', '02', '03','04', '05', '06', '07', '08', '10','12'], request.requestTypeValue.code)">
        <div class="card-header">Supervisor</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12">
                    <BaseEmployeeSelector v-model="request.supervisor"
                        label="Supervisor"
                        :v="$v.request.supervisor.userId"
                        :required="$v.request.supervisor.userId.$params.required ? true : false"
                        slug="supervisor"
                        tip="Enter employee’s last or first name or PCN to narrow list"
                        :showPcn="true"/>
                </b-col>
            </b-row>
        </div>
    </div>

    <div class="card" v-if="request.superPosition && request.superPosition === 'Y'">
        <div class="card-header">Supervisory Position</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="6">
                    <BaseMoneyInput v-model="request.superWorkAllocation"
                        :v="$v.request.superWorkAllocation"
                        slug="superWorkAllocation"
                        label="What percentage of time will be spend on supervisory activites?"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="6">
                     <BaseSelector v-model="request.superSameHours" 
                            :v="$v.request.superSameHours"
                            label="Will the supervisor work the same hours as their immediate supervisor?"
                            slug="superSameHours"
                            :options = yesNoOptions />
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseParagraphInput v-model="request.superSameHoursText"
                        v-if="request.superSameHours && request.superSameHours ==='N'"
                        :v="$v.request.superSameHoursText"
                        label="If no, please explain"
                        slug="superSameHoursText"
                        tip=""/>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="6">
                     <BaseSelector v-model="request.superDifferentLocation" 
                            :v="$v.request.superDifferentLocation"
                            label="Will the new supervisor be geographically separated from immediate supervisor''s location?"
                            slug="superDifferentLocation"
                            :options = yesNoOptions />
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseParagraphInput v-model="request.superDifferentLocationText"
                        v-if="request.superDifferentLocation && request.superDifferentLocation ==='Y'"
                        :v="$v.request.superDifferentLocationText"
                        label="If yes, please explain"
                        slug="superDifferentLocationText"
                        tip=""/>
                </b-col>
            </b-row>

             <b-row>
                <b-col class="mt-3">
                    <b-table-simple id="directReports" hover small caption-top  >
                        <b-thead>
                            <b-tr>
                                <b-th style="width: 30rem" colspan="3">Direct Reports</b-th>
                                <b-th style="width: 2rem">Remove</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in request.reports" :key="index">
                                <b-td>                                
                                    <BaseClassificationSelector v-model="item.classification"
                                        :v="$v.request.reports.$each[index].classification"
                                        label="Employee Classification"
                                        sr="Search for Employee Classification"/>
                                </b-td>
                                
                                <b-td>
                                    <BaseSelector v-model="item.empCondition" 
                                        :v="$v.request.reports.$each[index].empCondition"
                                        label="Employment Condition"
                                        :options = positionScheduleOptions />
                                </b-td>
                                <b-td>
                                    <BaseMoneyInput v-model="item.count"
                                        :v="$v.request.reports.$each[index].count"
                                        label="Employee Count"/>
                                </b-td>                            
                                <b-td>
                                    <b-button size="sm" variant="link" @click="removeReportsRow(index)"
                                        aria-label="remove direct report" title="remove direct report">
                                        <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                                    </b-button>
                                </b-td> 
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <b-button variant="outline-primary" size="sm"
                        @click="addReportsRow()">
                        Add additional direct report
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>

    <div class="card" v-if="_.includes(['09'], request.requestTypeValue.code)">
        <div class="card-header">Position Requirements</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.softwareExpNeeded"
                        v-if="_.includes(['09'], request.requestTypeValue.code)"
                        :v="$v.request.softwareExpNeeded" 
                        label="Software Experience Needed"
                        slug="softwareExpNeeded"
                        tip=""/>
                </b-col>
            </b-row>   

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.licCredsRequired"
                        v-if="_.includes(['09'], request.requestTypeValue.code)"
                        :v="$v.request.licCredsRequired" 
                        label="Required Licenses/Certifications"
                        slug="licCredsRequired"
                        tip=""/>
                </b-col>
            </b-row>               

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.specificStaffRequested"
                        v-if="_.includes(['09'], request.requestTypeValue.code)"
                        :v="$v.request.specificStaffRequested" 
                        label="Specific Staff Requested"
                        slug="specificStaffRequested"
                        tip=""/>
                </b-col>
            </b-row>               
        </div>
    </div>      


    <div class="card">
        <div class="card-header">Request Comments</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.comments"
                        :v="$v.request.comments" 
                        label="Comments"
                        slug="comments"
                        :required="$v.request.comments.$params.required ? true : false"
                        tip="Summarize in 1000 characters or less. Use attachments for more details as needed."/>
                </b-col>
            </b-row>  
        </div>
    </div>

    <div class="card">
        <div class="card-header">Attachments</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" md="2" style="margin-bottom:8px;">
                    <FileAttachment
                        :id="this.request.id"
                        :requestType="request.requestTypeValue"
                        :requestStatus="{'code': '01'}"
                        v-on:attachment-added="addAttachment"/>
                </b-col>
                <b-col v-if="requestTypeDescription" cols="12" md="4">
                    <strong>{{ requestTypeDescription }} Requests require the following attachments:</strong>
                    <p v-for="item in requiredAttachments" v-bind:key="item.value"
                        style="margin-left:11px; margin-top:8px;">
                        <span v-if="hasAttachment(item.value)">
                            <b-icon icon="check-box" scale="1.75" variant="success"></b-icon>
                        </span>
                        <span v-else>
                            <b-icon icon="x-circle" scale="1.75" variant="danger"></b-icon>
                        </span>
                        <span style="margin-left:12px;">{{item.text}}</span>
                    </p>
                </b-col>
                <b-col>
                    <b-table hover small show-empty
                        responsive="true"
                        :fields="attachmentFields"
                        :items="request.attachments"
                        :busy="false"
                        caption-top>      
                        <template #table-caption>Request Attachments</template>
                        <template v-slot:no-data>
                            No Attachments Found.
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>  
                        <template v-slot:cell(actions)="row">
                            <b-button size="sm" :href="row.item.url" target="_attach" class="mr-1"
                                aria-label="download" title="download">
                                download
                            </b-button>
                            <b-button size="sm" variant="link" @click="removeAttachment(row.index, row.item)"
                                aria-label="remove attachment" title="remove attachment">
                                        <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                            </b-button>


                        </template>
                        <template slot="empty" slot-scope="scope">
                            No Attachments Found.
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </div>
    </div>

    <div class="card" v-if="!_.includes(['10'], request.requestTypeValue.code)">
        <div class="card-header">Finance Information</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <p>Click on the link to <a href="https://fyi.web.health.state.mn.us/fadmin/finance/orgbdgt/dsp_COAReportPickFYPublic.cfm" target="_coa">SWIFT Chart of Accounts</a> to view current funding strings. PC BUS Unit: H1201</p>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-table-simple id="fundingStrs" hover small caption-top responsive >
                        <b-thead>
                            <b-tr>
                                <b-th style="width: 6rem">Percent</b-th>
                                <b-th>Fund</b-th>
                                <b-th>Fin Dept ID</b-th>
                                <b-th>Approp ID</b-th>
                                <b-th>SW Cost</b-th>
                                <b-th> Acct</b-th>
                                <b-th>Agcy Cost 1 </b-th>
                                <b-th> Agcy Cost 2</b-th>
                                <b-th>Project </b-th> 
                                <b-th>Activity</b-th>
                                <b-th style="width: 8rem">Source</b-th>
                                <b-th style="width: 2rem">Remove</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in request.funding" :key="index">
                                <b-td><b-form-input v-model="item.fundingPercent" aria-label="Percent"
                                    :class="{'is-invalid':$v.request.funding.$each[index].fundingPercent.$invalid, 
                                        'is-valid':!$v.request.funding.$each[index].fundingPercent.$invalid}" /></b-td>
                                <b-td><b-form-input v-model="item.fundId" aria-label="Fund"
                                    :class="{'is-invalid':$v.request.funding.$each[index].fundId.$invalid, 
                                        'is-valid':!$v.request.funding.$each[index].fundId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.divisionId" aria-label="Fin Dept ID"
                                    :class="{'is-invalid':$v.request.funding.$each[index].divisionId.$invalid, 
                                        'is-valid':!$v.request.funding.$each[index].divisionId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.appropriationId" aria-label="Approp ID"
                                    :class="{'is-invalid':$v.request.funding.$each[index].appropriationId.$invalid, 
                                        'is-valid':!$v.request.funding.$each[index].appropriationId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.swCost" aria-label="SW Cost" placeholder="SW Cost"/></b-td>
                                <b-td><b-form-input v-model="item.subAccount" aria-label="Sub Acct" placeholder="Sub Acct"/></b-td>
                                <b-td><b-form-input v-model="item.agcyCost1" aria-label="Agcy Cost 1" placeholder="Agcy Cost 1"
                                    :class="{'is-invalid':$v.request.funding.$each[index].agcyCost1.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].agcyCost1.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.agcyCost2" aria-label="Agcy Cost 2" placeholder="Agcy Cost 2"/></b-td>
                                <b-td><b-form-input v-model="item.project" aria-label="Project" placeholder="Project" maxlength="15" @keyup="maxLengthAlert"
                                    :class="{'is-invalid':$v.request.funding.$each[index].project.$invalid, 
                                        'is-valid':!$v.request.funding.$each[index].project.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.activity" aria-label="Activity" placeholder="Activity"
                                    :class="{'is-invalid':$v.request.funding.$each[index].activity.$invalid, 
                                        'is-valid':!$v.request.funding.$each[index].activity.$invalid}" /></b-td>
                                <b-td><b-form-select v-model="item.sourceType" aria-label="Source Type"
                                    :options="sourceTypeOptions"
                                    :class="{'is-invalid':$v.request.funding.$each[index].sourceType.$invalid, 
                                        'is-valid':!$v.request.funding.$each[index].sourceType.$invalid}"/></b-td>
                                <b-td>
                                    <b-button size="sm" variant="link" @click="removeFundingStringRow(index)"
                                        aria-label="remove funding string" title="remove funding string">
                                        <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                                    </b-button>
                                </b-td>
                            </b-tr>
                            <b-tr>
                              <b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td>
                              <b-td><span v-if="displayWarning" :class="{'text-danger': displayWarning}">Maximum of {{
                                  projectMaxLength
                                }} characters reached.</span></b-td>
                              <b-td></b-td><b-td></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <b-button variant="outline-primary" size="sm"
                        @click="addFundingStringRow()">
                        Add additional funding string
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>

    <div class="card" header-bg-variant="primary" header-text-variant="white"
        v-if="_.includes(['01', '02', '03','04', '05', '06', '07', '08','12'], request.requestTypeValue.code)">
        <div class="card-header">Additional Notifications</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="6">
                    <BaseTextInput v-model="request.notifyEmail1" 
                        :v="$v.request.notifyEmail1"
                        slug="notifyEmail1"
                        label="Optional First Notification"/>
                </b-col>
                <b-col cols="12" lg="6" v-if="isACApprovalRequired">
                    <BaseTextInput v-model="request.notifyEmail2" 
                        :v="$v.request.notifyEmail2"
                        slug="notifyEmail2"
                        label="Optional Second Notification"/>
                </b-col>
            </b-row>
        </div>
    </div>

    <div>
        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button type="button" variant="outline-primary" @click="saveDraft">Save as Draft</b-button>
    </div>
</b-form>
<div v-else>
    <strong>The form has been submitted.</strong>
    <p>This request was assigned a tracking number of {{ assignedId }}.</p>
</div>
</div>

</template>

<script>
import axios from "axios"
import _ from "lodash"
import { required, email, minLength, maxLength, numeric, decimal, requiredUnless, requiredIf, ref, minValue, maxValue, helpers } from 'vuelidate/lib/validators'
import isDivisionValid from '@/validators/isDivisionValid.js'
import minDate from '@/validators/minDate.js'
import FileAttachment from '@/components/FileAttachment.vue'
import { commonOptions } from '@/mixins/commonOptions.js'
import axiosRetry from 'axios-retry'
import { v4 as uuidv4 } from 'uuid'
import pageTitle from '@/mixins/pageTitle'
import BaseSema4Attributes from "@/components/BaseSema4Attributes.vue";
import {roleService} from "@/mixins/roleService";

const agcyValidator = (value) => !helpers.req(value) || (value >= 40000 && value <= 40002)
const terms = ['TBD', 'tbd']
const tbdValidator = (value) => !terms.some(el => value && value.indexOf(el) > -1)

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  })

export default {
    title: 'Submit New HRM Request',
    components: {
        BaseSema4Attributes,
        FileAttachment,
    },

    mixins: [
       commonOptions,
       pageTitle,
       roleService,
    ],

    data() {
        return {
            loading: false,
            keys: {
                requestType: 0,
            },
            requestTypeOptions: [],
            attachmentTypes: [],
            isSubmitted: false,
            assignedId: '',
            selectedSkills: [],
            hasOtherRequiredSkill: false,
            draftId: '',
            isACApprovalRequired: false,
            request: { 
                requestTypeValue: {
                    code: null,
                    text: '',
                },
                approvers: ['',''],
            },
              
            defaultRequestAttributes: {
                positionNumber: '',
                proposedClassification: '',
                previousIncumbent: '',
                classOption: '',
                workingTitle: '',
                positionLocation: '',
                hoursPerWeek: null,
                workingHours: '',
                anticipatedStartDate: null, 
                endDate: null, 
                division: '',
                departmentId: '',
                unitName: '',
                comments: '',
                supervisor: {
                    userId: '',
                    name: '',
                    email: '',
                    phoneNbr: '',
                    id: '',
                    pcn: '' ,
                    role: ''
                }, 
                requestTypeValue: {
                    code: null,
                    text: '',
                },
                positionScheduleValue: {
                    code: ''
                },
                appointmentValue: {
                    code: ''
                },
                workTravelValue: {
                    code: '',
                },
                workScheduleValue: {
                    code: '',
                },
                funding: [
                    
                ],
                reports: [

                ],
                approvers: [{},{}],
                approvals: [

                ],
                attachments: [

                ],
                type: '',
                coopLevel: '',
                dlRequired: '',
                teleworkAvailable: '',
                softwareExpNeeded: '',
                licCredsRequired: '',
                specificStaffRequested: '',
                notifyEmail1: '',
                notifyEmail2: '',
            },
            defaultFunding: {
                id: null, 
                fundingPercent: null, 
                fundId: '',
                divisionId: '',
                appropriationId: '',
                swCost: '',
                subAccount: '',
                agcyCost1: '',
                agcyCost2: '',
                project: '',
                activity: '',
                sourceType: '',
                remove: false,           
            },
            defaultReport: {
                id: null,
                classification: '',
                empCondition: '',
                count: null,
                remove: false,
            },
            
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            }, 
            attachmentFields:  [
                {key: 'filename', sortable: true, label: 'File Name'},
                {key: 'type', sortable: true, label: 'File Type', formatter: 'getFileType'},
                {key: 'actions', label: 'Actions'}
            ],
            attachmentRequirements: [],
            existingLeaveRequest: false,

            projectMaxLength: 15,
            displayWarning: false,

            pcnSema4Attributes: {
                asOfDate: '',
                posCd: '',
                deptId: '',
                deptLd: '',
                locLd: '',
                jobcodeLd: '',
                moptionCd: '',
                wjobOptionLd: '',
                reportsTo: '',
                regTempLd: '',
                clsIndLd: '',
                posFullPtCd: '',
                stdHours: '',
                posFtePct: '',
                flsaStatLd: '',
                unionCd: '',
            },
            fundingData: {
                isValid: '',
                positionNbr: '',
                distPct: '',
                fundCode: '',
                deptidCf: '',
                chartfield3: '',
                projectdescr: '',
                activityId: '',
                resourceType: '',
                seqNo: ''
            },
        }
    },

     watch: {
        selectedSkills: {
            deep: true,
            handler() {
                this.hasOtherRequiredSkill =  _.includes(this.selectedSkills, 'Other')
            }
        },

        request: {
            deep: true,
            handler() {
                if (this.request.requestTypeValue) {
                    this.isACApprovalRequired = (this.request.requestTypeValue.code === '08' ||
                        this.request.requestTypeValue.code === '02' ||
                        this.request.requestTypeValue.code === '01' ||
                        this.request.requestTypeValue.code === '12' ||
                        this.request.requestTypeValue.code === '04')
                } else {
                    this.isACApprovalRequired = true
                }

                if (this.request.requestTypeValue && this.request.requestTypeValue.code === '10'
                    && this.request.employee && this.request.employee.employeeId) {
                    this.doesEmployeeHaveExistingRequest()
                }

                if (this.request && this.request.positionScheduleValue) {
                    if (this.request.positionScheduleValue.code === 'F') {
                        this.request.hoursPerWeek = 40
                    } else {
                        if (this.request.hoursPerWeek && this.request.hoursPerWeek === 40) {
                            this.request.hoursPerWeek = null
                        }
                    }
                }
            }
        },
    },

    computed: {
        _: function() {
            return _
        },
        requestTypeDescription: function() {
            if (this.request.requestTypeValue) {
                for (let i = 0; i < this.requestTypeOptions.length; i++) {
                    if (this.requestTypeOptions[i].code === this.request.requestTypeValue.code) {
                        return this.requestTypeOptions[i].description
                    }
                }
            }
            return ""
        },

        requiredAttachments: function() {
            let results = []
            if (this.request.requestTypeValue) {
                for (let i = 0; i < this.attachmentRequirements.length; i++) {
                    if (this.attachmentRequirements[i].required
                        .includes(this.request.requestTypeValue.code)) {
                            results.push(this.attachmentRequirements[i])
                        }
                }
            }
            return results;
        },

        optionalAttachments: function() {
            let results = []
            for (let i = 0; i < this.attachmentRequirements.length; i++) {
                if (this.attachmentRequirements[i].optional
                    .includes(this.request.requestTypeValue.code)) {
                        results.push(this.attachmentRequirements[i])
                    }
            }
            return results;
        },

        activeFunding() {
            return _.filter (this.request.funding, function(fs) {
                return !fs.remove
            })
        },

        activeReports() {
            return _.filter (this.request.reports, function(fs) {
                return !fs.remove
            })
        },

        haveAllAttachments() {
            let haveAll = "true"
            if (this.request.attachments) {
                if (this.request.attachments.length === 0) {
                    haveAll = ""
                }
                for (let i = 0; i < this.requiredAttachments.length; i++) {
                    if (!this.hasAttachment(this.requiredAttachments[i].value)) {
                        haveAll = ""
                    }
                }
            } else {
                haveAll = ""
            }
            return haveAll
        },

        positionScheduleValue() {
            return this.request.positionScheduleValue.code
        },


        totalFundingStringPercent() {
            if (_.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)) { return "valid" }
            return _.sumBy(this.request.funding, item => Number(item.fundingPercent)) === 100 ? "valid" : ""
        }
    },

    validations() {
        return {
            haveAllAttachments: {
                required: requiredUnless(function() {
                    return _.includes(['09', '10'], this.request.requestTypeValue.code)
                }),
            },

            totalFundingStringPercent: {
                required
            },

            request: {     
                positionNumber: { 
                    required: requiredIf(function() {
                        return _.includes(['02', '03', '04', '05', '06', '07','12'], this.request.requestTypeValue.code)
                    }),
                    maxLength: maxLength(8) 
                },
                
                proposedClassification: { 
                    required: requiredIf(function() {
                        return _.includes(['01', '02', '03', '04', '05', '06', '07', '08','12'], this.request.requestTypeValue.code)
                    }) 
                },
                
                previousIncumbent: { 
                    required: false, 
                    maxLength: maxLength(50) 
                },

                classOption: { 
                    required: false, 
                    maxLength: maxLength(50) 
                },
                
                workingTitle: { 
                    required: false, 
                    maxLength: maxLength(50) 
                },
                
                positionLocation: { 
                    required: requiredIf(function() {
                        return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
                    }),
                    maxLength: maxLength(50),
                },

                hoursPerWeek: { 
                    required: requiredIf(function() {
                        return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
                    }),
                    numeric
                },
                
                workingHours: { 
                    required: requiredIf(function() {
                        return _.includes(['01', '02', '08'], this.request.requestTypeValue.code)
                    }),
                    maxLength: maxLength(50)
                },
                
                division: { 
                    required: requiredIf(function() {
                        return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10','12'], this.request.requestTypeValue.code)
                    }),
                    isDivisionValid 
                },

                departmentId: { 
                    required: requiredIf(function() {
                        return _.includes(['01', '02', '03', '04', '05', '06', '07', '08','12'], this.request.requestTypeValue.code)
                    }),
                },

                unitName: { 
                    required: false 
                },


                supervisor: {
                    userId: { 
                        required: requiredIf(function() {
                            return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '10','12'], this.request.requestTypeValue.code)
                        }),
                    }
                }, 

                employee: {
                    employeeId: {
                        required: requiredIf(function() {
                            return _.includes(['10'], this.request.requestTypeValue.code)
                        }),
                    }
                }, 

                leaveType: { 
                    required: requiredIf(function() {
                        return _.includes(['10'], this.request.requestTypeValue.code)
                    })
                },

                workStatus: { 
                    required: false,
                    maxLength: maxLength(100)
                },

                leaveDecision: { 
                    required: false,
                    maxLength: maxLength(100)
                },

            
                comments: { 
                    required: false, 
                    maxLength: maxLength(4000)
                },

                requestTypeValue: {
                    code: { 
                        required: true 
                    }
                },
                
                positionScheduleValue: {
                    code: { 
                        required: requiredIf(function() {
                            return _.includes(['01', '02', '08', '09', '10'], this.request.requestTypeValue.code)
                        })
                    }
                },

                appointmentValue: {
                    code: { 
                        required: requiredIf(function() {
                            return _.includes(['01', '02', '03', '04', '05', '06', '08','12'], this.request.requestTypeValue.code)
                        })
                    }
                },

                workScheduleValue: {
                    code: { 
                        required: requiredIf(function() {
                            return _.includes(['09'], this.request.requestTypeValue.code)
                        })
                    }
                },

                workTravelValue: {
                    code: {  
                        required: requiredIf(function() {
                            return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
                        }) 
                    }
                },
                
                anticipatedStartDate: { 
                    required: requiredIf(function() {
                        return _.includes(['01', '02', '08', '09', '10'], this.request.requestTypeValue.code)
                    })
                },
                endDate: { 
                    required: requiredIf(function() {
                        return _.includes(['07', '09', '10'], this.request.requestTypeValue.code) ||
                                (this.request.appointmentValue && this.request.appointmentValue.code === 'N')
                    }),
                    minDate: minDate(this.request.anticipatedStartDate)
                },
                timeLimitedReason: { 
                    required: requiredIf(function() {
                        return this.request.appointmentValue && this.request.appointmentValue.code === 'N'
                    }),
                    maxLength: maxLength(4000),
                },
                endWhenWorkComplete: { 
                    required: requiredIf(function() {
                        return this.request.appointmentValue && this.request.appointmentValue.code === 'N'
                    }),
                    maxLength: maxLength(5),
                },
                purposeOfPosition: { 
                    required: requiredIf(function() {
                        return this.request.appointmentValue && this.request.appointmentValue.code === 'N'
                    }),
                    maxLength: maxLength(4000),
                },                                

                notifyEmail1: { required: false, email },
                notifyEmail2: { required: false, email },

                superPosition: {
                    required: false,
                    maxLength: maxLength(5)
                },
                
                superWorkAllocation: {
                    decimal,
                    minValue: minValue(0),
                    maxValue: maxValue(100),
                    required: requiredIf(function() {
                        return this.request.superPosition && this.request.superPosition === 'Y'
                    })
                },

                superSameHours: {
                    required: requiredIf(function() {
                        return this.request.superPosition && this.request.superPosition === 'Y'
                    })
                },

                superSameHoursText: {
                    required: requiredIf(function() {
                        return this.request.superSameHours && this.request.superSameHours === 'N'
                    }),
                    maxLength: maxLength(4000)
                },

                superDifferentLocation: {
                    required: requiredIf(function() {
                        return this.request.superPosition && this.request.superPosition === 'Y'
                    })
                },

                superDifferentLocationText: {
                    required: requiredIf(function() {
                        return this.request.superDifferentLocation && this.request.superDifferentLocation === 'Y'
                    }),
                    maxLength: maxLength(4000)
                },

                reports: {
                    required: requiredIf(function() {
                        return this.request.superPosition && this.request.superPosition === 'Y'
                    }),
                    minLength: minLength((this.request.superPosition && this.request.superPosition === 'Y' ?  1: 0)),
                    $each: {
                        classification: {
                            required:  requiredIf(function() {
                                return this.request.superPosition && this.request.superPosition === 'Y'
                        })
                        },
                        empCondition: {
                            required:  requiredIf(function() {
                                return this.request.superPosition && this.request.superPosition === 'Y'
                        })
                        },
                       count: {
                           numeric,
                            required:  requiredIf(function() {
                                return this.request.superPosition && this.request.superPosition === 'Y'
                        })
                        },                  
                    }
                },

                funding: {
                    required: requiredUnless(function() {
                        return _.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)
                    }),
                    minLength: minLength(1),
                    $each: {
                        fundingPercent: {
                            required: requiredUnless(function() {
                                return _.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)
                            }),
                            numeric
                        },
                        fundId: {
                            required: requiredUnless(function() {
                                return _.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)
                            }),
                            tbdValidator
                        },
                        divisionId: {
                            required: requiredUnless(function() {
                                return _.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)
                            }),
                            tbdValidator
                        },
                        sourceType: {
                            required: requiredIf(function(item) {
                                return item.project || item.activity
                            }),
                        },
                        appropriationId: {
                            required: requiredUnless(function() {
                                return _.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)
                            }),
                            tbdValidator
                        },
                        agcyCost1: {
                          required: requiredIf(function(item) {
                            return item.divisionId.endsWith('3201')
                          }),
                          agcyValidator,
                          tbdValidator
                        },
                        project: {
                            required: requiredIf(function(item) {
                                return ((item.fundId === '3000' || item.fundId === '3001') ||
                                        (item.activity || item.sourceType))
                            }),
                            tbdValidator
                        },
                        activity: {
                            required: requiredIf(function(item) {
                                return item.project || item.sourceType
                            }),
                            maxLength: maxLength(15),
                            tbdValidator
                        }
                    }
                },

                coopLevel: {
                    required: requiredIf(function() {
                        return _.includes(['09'], this.request.requestTypeValue.code)
                    })
                },

                dlRequired: {
                    required: requiredIf(function() {
                        return _.includes(['09'], this.request.requestTypeValue.code)
                    })
                },

                teleworkAvailable: {
                    required: false,
                    maxLength: maxLength(1000) 
                },

                softwareExpNeeded: {
                    required: false,
                    maxLength: maxLength(1000)
                },

                licCredsRequired: {
                    required: requiredIf(function() {
                        return _.includes(['09'], this.request.requestTypeValue.code)
                    }),
                    maxLength: maxLength(1000)
                }, 

                specificStaffRequested: {
                    required: false,
                    maxLength: maxLength(4000)
                }, 

                otherSkillSet: {
                    required: false,
                    maxLength: maxLength(100)
                },

                approvers: {
                    required: requiredIf(function() {
                        return !_.includes(['10', '13'], this.request.requestTypeValue.code)
                    })

                },
            }
        }
    },

    created() { 
        this.loadRequestTypes()
        this.loadAttachmentTypes()
        this.loadAttachmentReqs()

         // check to see if a draft id was sent in the query parameters
        if (this.$route.params.draftId) {
            this.loading = true
            this.loadDraft(this.$route.params.draftId)
            window.scrollTo(0,0)
        } else {
            this.request = Object.assign(this.defaultRequestAttributes)
        }

        this.addFundingStringRow()
       // this.addReportsRow()

        this.autosave()
    },

    beforeDestroy() {
       clearInterval(this.autosave_id)
    },

    methods: {
      autosave() {
          this.autosave_id = setInterval(() => {
              this.saveDraft()
          }, 300000);
      },

        loadRequestTypes() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/requesttype`)
            .then(response => {
                this.requestTypeOptions = response.data
            })
        },

      loadAttachmentTypes() {
          if (this.hasInternalAttachmentsRole()) {
              axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachment/types/all`)
                  .then(response => {
                      this.attachmentTypes = response.data
                  })
          } else {
              axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachment/types/ext`)
                  .then(response => {
                      this.attachmentTypes = response.data
                  })
          }
      },

      loadAttachmentReqs() {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirements`, {statusCode: "01"})
          .then(response => {
            for (let i=0; i<response.data.length; i++) {
              let index = this.attachmentRequirements.findIndex(e => e.value === response.data[i].attachmentTypeValue.code)
              if (index < 0) {
                let obj = {
                  value: response.data[i].attachmentTypeValue.code,
                  text: response.data[i].attachmentTypeValue.description,
                  required: [],
                  optional: []
                }
                if (response.data[i].required) {
                  obj.required.push(response.data[i].requestTypeValue.code)
                } else {
                  obj.optional.push(response.data[i].requestTypeValue.code)
                }
                this.attachmentRequirements.push(obj)
              } else {
                if (response.data[i].required) {
                  this.attachmentRequirements[index].required.push(response.data[i].requestTypeValue.code)
                } else {
                  this.attachmentRequirements[index].optional.push(response.data[i].requestTypeValue.code)
                }
              }
            }
          })

      },

        addFundingStringRow() {
            var newFunding = {... this.defaultFunding}
            if (this.request.funding) {
                this.request.funding.push(newFunding)
            }
        },

        removeFundingStringRow(idx) {
            if (this.request.funding && this.request.funding.length > 1) {
                this.request.funding.splice(idx, 1)
            }
        },

        addReportsRow() {
            var newReport = {... this.defaultReport}
            if (!this.request.reports) {
                this.request.reports = []
            }
            this.request.reports.push(newReport)

        },

        removeReportsRow(idx) {
            if (this.request.reports && this.request.reports.length > 1) {
                this.request.reports.splice(idx, 1)
            }
        },

        padPositionNumber() {
            this.request.positionNumber = String(this.request.positionNumber).padStart(8, '0')
        },

        onSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

             if (this.existingLeaveRequest) {
                this.$bvModal.show('modal-existing-confirm')
                let confirmation = false

                this.$bvModal.msgBoxConfirm('The employee already has an unclosed leave request.  Do you wish to save another?', {
                    title: 'Confirm Leave Request',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    confirmation = value

                    if (!confirmation) {
                        return
                    }
                    this.sendToServer()
                })
            } else {
                this.sendToServer()
            }
        },

        sendToServer() {
            this.request.skillSet = this.selectedSkills.join("; ")

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request`, this.request)
                .then(response => {
                    this.isSubmitted = true
                    this.assignedId = response.data.id
                    this.deleteDraft()
            })
        },

        updateDivision() {
            if (this.request.division && this.request.requestTypeValue && !this.loading) {
                var payload = {
                    division: this.request.division,
                    requestTypeValue: this.request.requestTypeValue.code
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/division/auto`, payload)
                    .then(response => {
                        this.request.divisionDirector = response.data.divisionDirector
                        this.request.assistantCommissioner = response.data.assistantCommissioner
                        this.request.staffingSpecialist = response.data.staffingSpecialist
                        this.$forceUpdate()
                    })
            }
        },

        deleteDraft() {
             if (this.draftId) {
                axios.delete(`${process.env.VUE_APP_API_BASE_URL}/drafts/${this.draftId}`)
                .then(response => {
                    console.log('deleted draft ' + this.draftId)
                })
            }
        },

        saveDraft() {
            if (!this.draftId) {
                this.draftId = uuidv4()
            }

            var payload = this.request

            var draft = {
                id: this.draftId,
                payload: this.request
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/drafts/save`, draft)
                .then(response => {
                    if (response.data) {
                        console.log('saved draft ' + draft.id)
                        this.showRootToast("HRM Request Draft has been saved", "Success", "success")
                    }
            })
        },

        loadDraft(id) {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/drafts/${id}`)
                .then(response => { 
                    if (response.data) {
                        this.request = response.data.payload
                        this.draftId = id
                        if (!this.request.reports) {
                            this.request.reports = []
                        }
                        if (!this.request.approvers) {
                            this.request.approvers = ['','']
                        }
                    }
                    this.loading = false
            })
        },

        addAttachment(value) {
            this.request.attachments.push(value)
        },

        removeAttachment(idx, item) {
            axios.delete(`${process.env.VUE_APP_API_BASE_URL}/attachment/${item.id}`)
                .then(response => {
                    this.request.attachments.splice(idx, 1)
                })
        },

      getFileType(value) {
        for (let i=0; i<this.attachmentTypes.length; i++) {
          if (this.attachmentTypes[i].code == value) {
            return this.attachmentTypes[i].description
          }
        }
        return 'Unknown'
      },
        
        hasAttachment(attachmentType) {
            let found = this.request.attachments.find(a => a.type === attachmentType)
            return found
        },

        doesEmployeeHaveExistingRequest() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/pending/${this.request.employee.employeeId}`)
                  .then(response => {
                    this.existingLeaveRequest = response.data.exists
                  })
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })
        },
      goBack(){
        //Requests is routed twice, so we need to go back 2 in order to get to the right place
        this.$router.back()
      },

        maxLengthAlert(event) {
          let newValue = event.target.value;
          if (newValue.length >= this.projectMaxLength) {
            event.preventDefault()
            this.address = this.previousAddress;
            this.displayWarning = true;
          }
          else {
            this.address = newValue;
            this.previousAddress = newValue;
            this.displayWarning = false;
          }
        },

        getSema4AttributesOfCurrentPcn(pcn) { // TODO: make this better
            axios.get(`${process.env.VUE_APP_ADMINWS_API_BASE_URL}/sema4/${pcn}`)
                .then(response => {
                    if (response.data.length > 0)  {
                        this.pcnSema4Attributes = response.data
                        console.log(this.pcnSema4Attributes)

                        this.loading = false
                    } else {
                        this.pcnSema4Attributes = ['']
                    }
                }).catch(() => {
                    this.pcnSema4Attributes = ['']
                    this.pcnSema4Attributes.posCd = "Error finding PCN."
                })
            // this.pcnSema4Attributes.fundingData.validPcn = 'loading...'
            axios.get(`${process.env.VUE_APP_ADMINWS_API_BASE_URL}/sema4/${pcn}/funding`)
                .then(response => {
                    if (response.data.length > 0)  {
                        console.log(response.data)
                        this.fundingData = response.data
                        this.fundingData.isValid = ''

                    } else {
                        this.fundingData = ['']
                        this.fundingData.isValid = 'No PCN funding data found.'
                    }
                }).catch(() => {
                this.fundingData.isValid = "Error finding PCN funding data."
            })
        },

    }   
}
</script>

<style>
.card {
    margin-bottom: 18px;
}
.card-header {
    font-weight: 700;
}

fieldset > legend {
    font-weight: 750;
}
</style>
